<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
export default {
  components: { FontAwesomeIcon },
  props: {
    file: {
      type: Object,
      required: true,
    },
    btnClass: {
      type: String,
      default: 'mr-4',
    },
    fileName: {
      type: String,
      default: null,
    },
    removable: {
      type: Boolean,
      default: true,
    },
    smallText: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    download() {
      this.$wait.start('downloading');
      this.$http.get(`files/${this.file.id}`, { responseType: 'arraybuffer' }).then((response) => {
        this.$wait.end('downloading');
        const headers = response.headers;
        const blob = new Blob([response.data], { type: headers['content-type'] });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.file.name;
        link.click();
      });
    },
  },
};
</script>

<template>
  <div v-if="file" class="d-flex align-items-center no-wrap">
    <b-link :disabled="$wait.is('downloading')" :class="btnClass" @click="download">
      <slot></slot>
      <template v-if="smallText">
        <small>&nbsp;{{ fileName || file.name }}</small>
      </template>
      <template v-else>
        {{ fileName || file.name }}
      </template>
      <FontAwesomeIcon v-if="$wait.is('downloading')" icon="spinner" spin />
    </b-link>
    <b-link v-if="removable" :disabled="disabled" class="text-secondary" @click="$emit('remove', file)">&times;</b-link>
  </div>
</template>
